module.exports = __webpack_public_path__ + "img/delete_forever-24px.1054993a.svg";